$(document).ready(function () {
    let ckeditors = {};
    const $modal = $('#formModal');
    const $form = $('#modalForm');
    const $title = $('#modalTitle');
    const $method = $form.find('input[name="_method"]');
    const $registroId = $('#registro_id');
    const $formFields = $('#formFields');
    const tipo = $('.gestor-wrapper').data('tipo'); // Asume que pasas el tipo como <body data-tipo="promociones">
    $('#submitBtn').on('click', function () {
        $('.form-error').text('');
        $('input, select, textarea').removeClass('is-invalid');

        // ✅ CKEditor 5: pasar el contenido del editor al <textarea>
        for (const name in ckeditors) {
            const editor = ckeditors[name];
            const data = editor.getData();
            $(`textarea[name="${name}"]`).val(data);
        }

        $form.trigger('submit');
    });

    // Abrir modal para nuevo (vía fetch de campos y relaciones)
    $('#openCreateModal').on('click', function (e) {
        e.preventDefault();

        $.get(`/admin/gestionar/${tipo}/create`, function (data) {
            openModal('create', data);
        });
    });
    // Cerrar modal
    $('#closeModal').on('click', function () {
        if ($form[0]) {
            $form[0].reset();
        }

        // 🧹 CKEditor 5: destruir instancias al cerrar el modal
        for (const id in ckeditors) {
            if (ckeditors[id]) {
                ckeditors[id].destroy().catch(error => console.error(error));
            }
        }
        ckeditors = {};

        $('.form-error').text('');
        $formFields.empty();
        $modal.addClass('hidden');
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $modal.addClass('hidden');
        }
    });
    // Abrir modal para editar (con datos vía fetch)
    $('.openEditModal').on('click', function (e) {
        e.preventDefault();
        const id = $(this).data('id');

        $.get(`/admin/gestionar/${tipo}/${id}/edit`, function (data) {
            openModal('edit', data);
        });
    });
    // Drag & Drop + Preview
    const dropArea = $('#dropArea');
    const input = $('#imagenInput');
    const preview = $('#previewImage');
    const dropText = $('#dropText');
    dropArea.on('dragover', function (e) {
        e.preventDefault();
        dropArea.addClass('dragover');
    });
    dropArea.on('dragleave', function () {
        dropArea.removeClass('dragover');
    });
    dropArea.on('drop', function (e) {
        e.preventDefault();
        dropArea.removeClass('dragover');
        const file = e.originalEvent.dataTransfer.files[0];
        input[0].files = e.originalEvent.dataTransfer.files;
        showPreview(file);
    });
    input.on('change', function () {
        const file = this.files[0];
        showPreview(file);
    });
    $form.on('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this);
        const action = $form.attr('action');
        const method = $method.val();
    
        $('.form-error').text(''); // Limpia errores anteriores
    
        $.ajax({
            url: action,
            method: method === 'PUT' ? 'POST' : method,
            data: formData,
            contentType: false,
            processData: false,
            headers: method === 'PUT' ? { 'X-HTTP-Method-Override': 'PUT' } : {},
            success: function (response) {
                if (response.redirect && response.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: response.success,
                        confirmButtonColor: '#2563eb'
                    }).then(() => {
                        window.location.href = response.redirect;
                    });
                    $modal.addClass('hidden');
                } else {
                    location.reload();
                }            
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    const errors = xhr.responseJSON.errors;
                    for (const field in errors) {
                        const $input = $(`[name="${field}"]`);
                        $input.addClass('is-invalid');
                        $(`#${field}Error`).text(errors[field][0]);
                    }
                } else if (xhr.status === 500) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.',
                        confirmButtonColor: '#2563eb'
                    });
                }
            }
        });
    });
    $('.deleteRecord').on('click', function (e) {
        e.preventDefault();
        const id = $(this).data('id');
        const tipo = $('.gestor-wrapper').data('tipo');
    
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Sí, eliminar'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: `/admin/gestionar/${tipo}/${id}`,
                    method: 'POST',
                    data: { _method: 'DELETE', _token: $('meta[name="csrf-token"]').attr('content') },
                    success: function (response) {
                        Swal.fire('Eliminado', response.success || 'El registro ha sido eliminado.', 'success')
                            .then(() => location.reload());
                    },
                    error: function () {
                        Swal.fire('Error', 'No se pudo eliminar el registro.', 'error');
                    }
                });
            }
        });
    }); 
    //Filtro
    const searchInput = document.getElementById('searchInput');
    const searchSelect = document.getElementById('searchField');
    if(searchInput && searchSelect){
        searchInput.addEventListener('input', () => {
            clearTimeout(window.searchDelay);
            window.searchDelay = setTimeout(updateSearch, 500);
        });
    
        searchSelect.addEventListener('change', updateSearch);
    }
    //Modal cupones
    const cuponModal = document.getElementById('cuponModal');
    const closeCuponModal = document.getElementById('closeCuponModal');
    //Generar cupones en gestor
    document.querySelectorAll('.generarCuponesBtn').forEach(btn => {
        btn.addEventListener('click', () => {
            const id = btn.dataset.id;
            document.getElementById('cuponModal_elemento_id').value = id;
            cuponModal.classList.remove('hidden');
        });
    });
    //Generar cupones en cupones
    document.querySelectorAll('.generarCuponesBtn2').forEach(btn => {
        btn.addEventListener('click', () => {
            const id = btn.dataset.relacionado;
            const tipo = btn.dataset.tipo;
            document.getElementById('cuponModal_elemento_id').value = id;
            document.getElementById('cuponModal_tipo').value = tipo;
            cuponModal.classList.remove('hidden');
        });
    });
    if(closeCuponModal){
        closeCuponModal.addEventListener('click', () => {
            cuponModal.classList.add('hidden');
        });
    }


    function activarDropArea(field) {
        const input = $(`#imagenInput-${field}`);
        const preview = $(`#previewImage-${field}`);
        const dropArea = $(`#dropArea-${field}`);
        const dropText = $(`#dropText-${field}`);
    
        if (dropArea.length && input.length) {
            dropArea.on('dragover', function (e) {
                e.preventDefault();
                dropArea.addClass('dragover');
            });
    
            dropArea.on('dragleave', function () {
                dropArea.removeClass('dragover');
            });
    
            dropArea.on('drop', function (e) {
                e.preventDefault();
                dropArea.removeClass('dragover');
                const file = e.originalEvent.dataTransfer.files[0];
                input[0].files = e.originalEvent.dataTransfer.files;
                showPreview(file, preview, dropText);
            });
    
            input.on('change', function () {
                const file = this.files[0];
                showPreview(file, preview, dropText);
            });
        }
    }
    function showPreview(file, previewEl, textEl) {
        if (!file || !file.type.startsWith('image/')) return;
        const reader = new FileReader();
        reader.onload = function (e) {
            previewEl.attr('src', e.target.result).show();
            textEl.hide();
        };
        reader.readAsDataURL(file);
    }
    function updateSearch() {
        const q = searchInput.value.trim();
        const field = searchSelect.value;

        const url = new URL(window.location.href);
        url.searchParams.set('q', q);
        url.searchParams.set('field', field);

        window.location.href = url.toString();
    }
    function openModal(mode, data = {}) {
        $modal.removeClass('hidden');
        $title.text(mode === 'edit' ? 'Editar registro' : 'Nuevo registro');
        $method.val(mode === 'edit' ? 'PUT' : 'POST');
        $registroId.val(data.id || '');

        $form.attr('action', mode === 'edit'
            ? `/admin/gestionar/${tipo}/${data.id}`
            : `/admin/gestionar/${tipo}`
        );

        // Mostrar loader con fade-in
        $('#modalLoader').removeClass('hidden').addClass('show');
        $formFields.removeClass('show').addClass('hidden');

        setTimeout(() => {
            renderFields(mode, data);
    
            // Ocultar loader y mostrar campos con fade
            $('#modalLoader').removeClass('show').addClass('fade');
            setTimeout(() => {
                $('#modalLoader').css('display', 'none');
                $formFields.removeClass('hidden').addClass('show');
            }, 300);
        }, 300);
    }
    const paginasDisponibles = [
        { value: '/', label: 'Página principal (home)' },
        { value: 'tiendas', label: 'Tiendas' },
        { value: 'promociones-tiendas', label: 'Promociones' },
        { value: 'horarios-aperturas', label: 'Horarios/Aperturas' },
        { value: 'donde-comer', label: 'Donde comer' },
        { value: 'ocio-infantil', label: 'Ocio Infantil' },
        { value: 'actividades-agenda', label: 'Actividades/Agenda' },
        { value: 'zona-descargas', label: 'Descarga tus fotos o videos' },
        { value: 'nuestro-centro', label: 'Nuestro centro' }
    ];
    function renderFields(mode, data) {
        const campos = (data._fields || []).filter(f => f !== 'baner');
        const relaciones = data._relaciones || {};
        let html = '';
        //Campo banner
        if (['tiendas', 'eventos', 'promociones'].includes(tipo)) {
            const baner = data.baner || {};
            html += `
                <div class="form-group">
                    <label>Imagen de cabecera</label>
                    <div class="drop-area" id="dropArea-baner_imagen">
                        <span id="dropText-baner_imagen">Haz clic o arrastra una imagen aquí</span>
                        <input type="file" name="baner_imagen" id="imagenInput-baner_imagen" accept="image/*">
                        <img class="previewImage" id="previewImage-baner_imagen" src="${baner.imagen_url || ''}" style="display:${baner.imagen_url ? 'block' : 'none'};">
                    </div>
                    <div class="form-error" id="baner_imagenError"></div>
                </div>
                <div class="form-group" style="display:none;">
                    <label>Orden del banner</label>
                    <input type="number" name="baner_orden" value="${baner.orden || 0}">
                </div>
                <div class="form-group switch-group">
                    <label>Cabecera Activa</label>
                    <label class="switch">
                        <input type="checkbox" name="baner_activo" ${baner.activo ? 'checked' : ''}>
                        <span class="slider"></span>
                    </label>
                </div>
                <input type="hidden" name="baner_id" value="${baner.id || ''}">
            `;
        }
        delete data.baner;
        campos.forEach(field => {
            const label = field.replace('_id', '').replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            let valor = data[field] ?? '';
            const key = field.endsWith('_id') ? field : `${field}_id`;
            //Campo imagen
            if (field.includes('imagen') || field.includes('logo') || field.includes('mapa_planta0') || field.includes('mapa_plantam1') || field.includes('image')) {
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <div class="drop-area" id="dropArea-${field}">
                            <span id="dropText-${field}">Haz clic o arrastra una imagen aquí</span>
                            <input type="file" name="${field}" id="imagenInput-${field}" accept="image/*">
                            <img class="previewImage" id="previewImage-${field}" src="${valor || ''}" alt="Vista previa" style="display:${valor ? 'block' : 'none'};">
                        </div>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            //Campo select
            } else if (field.endsWith('_id')) {
                const relacion = relaciones[field] || relaciones[field.replace('_id', '')] || [];
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <select name="${field}">
                            <option value="">Selecciona una opción</option>
                            ${relacion.map(rel => `
                                <option value="${rel.id}" ${rel.id == valor ? 'selected' : ''}>
                                    ${rel.nombre || rel.name || rel.titulo || rel.id}
                                </option>
                            `).join('')}
                        </select>
                    </div>
                `;
            //Campo text area
            } else if (field.includes('descripcion')) {
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <textarea name="${field}" rows="4">${valor}</textarea>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            //Campo fecha
            } else if (field.includes('fecha') || field.includes('fecha_inicio') || field.includes('fecha_fin')) {
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <input type="date" name="${field}" value="${valor}">
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            } else if (field == 'id' || field == 'email_verified_at' || field == 'password' || field == 'remember_token' || field == 'reset_token') { 
                return;
            //Campo checkbox
            } else if (field.includes('activo')) {
                html += `
                    <div class="form-group switch-group">
                        <label>Elemento ${label}</label>
                        <label class="switch">
                            <input type="checkbox" name="${field}" ${valor == 1 ? 'checked' : ''}>
                            <span class="slider"></span>
                        </label>
                    </div>
                `;             
            //Campo checkbox
            } else if (field === 'destacado') {
                html += `
                    <div id="field_destacado">
                        <div class="form-group switch-group">
                            <label>Elemento ${label}</label>
                            <label class="switch">
                                <input type="checkbox" name="destacado" ${valor == 1 ? 'checked' : ''}>
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                `;
                // Campo adicional para páginas destacadas
                setTimeout(() => {
                    const checkbox = $form.find('input[name="destacado"]');
                    const paginasSeleccionadas = data.paginas_destacadas || [];

                    function togglePaginasField() {
                        if (checkbox.prop('checked')) {
                            renderPaginasDestacadasField(paginasSeleccionadas);
                        } else {
                            $('#field_paginas_destacadas').remove();
                        }
                    }
                    checkbox.on('change', togglePaginasField);
                    if (checkbox.prop('checked')) togglePaginasField();
                }, 100);       
            //Campo multiselect
            } else if (Array.isArray(valor)) {
                const relacion = relaciones[field] || relaciones[field.replace('_id', '')] || [];
                html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <select name="${field}[]" multiple>
                            ${relacion.map(rel => `
                                <option value="${rel.id}" ${valor.includes(rel.id) ? 'selected' : ''}>
                                    ${rel.nombre || rel.titulo || rel.id}
                                </option>
                            `).join('')}
                        </select>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                `;
            } else if (field === 'paginas_destacadas') {
                return;
            } else {
                const isDatoReadOnly = (tipo === 'corporativo' && field === 'dato') ? 'readonly' : '';
                if(tipo === 'corporativo' && valor.length >  255){
                    html += `
                    <div class="form-group">
                        <label>${label}</label>
                        <textarea name="${field}" rows="4">${valor}</textarea>
                        <div class="form-error" id="${field}Error"></div>
                    </div>
                    `;
                } else {
                    if(field === 'planta') {
                        html += `
                             <div class="form-group">
                                <label>${label}</label>
                                <select name="${field}">
                                    <option value="">Selecciona una opción</option>
                                    <option ${valor == '0' ? 'selected' : ''} value="0">Planta 0</option>
                                    <option ${valor == '-1' ? 'selected' : ''} value="-1">Planta -1</option>
                                    <option ${valor == 'ambas' ? 'selected' : ''} value="ambas">Ambas</option>
                                </select>
                            </div>
                        `;
                    }else{
                        html += `
                            <div class="form-group">
                                <label>${label}</label>
                                <input type="text" name="${field}" value="${valor}" ${isDatoReadOnly}>
                                <div class="form-error" id="${field}Error"></div>
                            </div>
                        `;
                    }
                }
            }
        });

        if (mode === 'edit') {
            Object.entries(data).forEach(([key, value]) => {
                // Mostrar solo si es un array de objetos y NO es una relación many-to-many
                if (Array.isArray(value) && value.length && typeof value[0] === 'object') {
                    // Evitar repetir las relaciones many-to-many que ya están en campos
                    if (!campos.includes(key)) {
                        html += `
                            <div class="form-group">
                                <label>${key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</label>
                                <ul>
                                    ${value.map(item => {
                                        const preview = item.numero_local || item.nombre || item.titulo || item.id;
                                        const extra = item.planta ? ` (Planta ${item.planta})` : '';
                                        return `<li>${preview}${extra}</li>`;
                                    }).join('')}
                                </ul>
                            </div>
                        `;
                    }
                }
            });
        }
        setTimeout(() => {
            // Inicializa drag and drop para cada campo de imagen
            $('[type="file"][accept*="image"]').each(function () {
                const input = $(this);
                const field = input.attr('name');
                const dropArea = $(`#dropArea-${field}`);
                const preview = $(`#previewImage-${field}`);
                const dropText = $(`#dropText-${field}`);
        
                dropArea.on('dragover', function (e) {
                    e.preventDefault();
                    dropArea.addClass('dragover');
                });
        
                dropArea.on('dragleave', function () {
                    dropArea.removeClass('dragover');
                });
        
                dropArea.on('drop', function (e) {
                    e.preventDefault();
                    dropArea.removeClass('dragover');
                    const file = e.originalEvent.dataTransfer.files[0];
                    input[0].files = e.originalEvent.dataTransfer.files;
                    showPreview(file, preview, dropText);
                });
        
                input.on('change', function () {
                    const file = this.files[0];
                    showPreview(file, preview, dropText);
                });
            });
        }, 100);
        
        $formFields.html(html);
        setTimeout(() => {
            reiniciarCKEditor();
        }, 100);

    }
    activarDropArea('logo');
    activarDropArea('baner');

    function renderPaginasDestacadasField(selected = []) {
        const html = `
            <div class="form-group" id="field_paginas_destacadas">
                <label>Páginas donde destacar</label>
                <select name="paginas_destacadas[]" multiple class="form-control">
                    ${paginasDisponibles.map(p => `
                        <option value="${p.value}" ${selected.includes(p.value) ? 'selected' : ''}>
                            ${p.label}
                        </option>
                    `).join('')}
                </select>
                <div class="form-error" id="paginas_destacadasError"></div>
            </div>
        `;
        $('#field_destacado').append(html);
    }
    function reiniciarCKEditor() {
        // Destruir editores anteriores si existen
        for (const id in ckeditors) {
            if (ckeditors[id]) {
                ckeditors[id].destroy().catch(error => console.error(error));
            }
        }
        ckeditors = {}; // Reiniciar el objeto

        // Crear nuevas instancias para todos los textarea visibles
        document.querySelectorAll('textarea').forEach(textarea => {
            ClassicEditor
                .create(textarea)
                .then(editor => {
                    ckeditors[textarea.name] = editor; // Guardamos por name
                })
                .catch(error => {
                    console.error(`Error al inicializar CKEditor en ${textarea.name}`, error);
                });
        });
    }


    $(document).on('click', '.btn-toggle-estado', function () {
        const id = $(this).data('id');
        const modelo = $(this).data('modelo');
        const boton = $(this);

        $.get(`/admin/gestionar/${modelo}/toggle-estado/${id}`, function (response) {
            if (response.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'El estado del registro ha sido actualizado.',
                    confirmButtonColor: '#2563eb'
                });
                window.location.reload();
            } else {
                alert('Error: ' + response.message);
            }
        });
    });



});


